
/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
const getSessionStorageArray = (key) => {
  try {
    const rawData = sessionStorage.getItem(key);
    if (!rawData) return [];
    
    const parsedData = JSON.parse(rawData);
    // 确保返回的是数组
    return Array.isArray(parsedData) ? parsedData : [];
  } catch (error) {
    console.error(`解析sessionStorage中${key}失败:`, error);
    return [];
  }
};
export function checkPermi(value) {
  if (value && value instanceof Array && value.length > 0) {
    const permissions = getSessionStorageArray('permissions')
    const permissionDatas = value
    const all_permission = "*:*:*";

    const hasPermission = permissions.some(permission => {
      return all_permission === permission || permissionDatas.includes(permission)
    })

    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like checkPermi="['system:user:add','system:user:edit']"`)
    return false
  }
}

/**
 * 角色权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkRole(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = getSessionStorageArray('roles')
    const permissionRoles = value
    const super_admin = "admin";

    const hasRole = roles.some(role => {
      return super_admin === role || permissionRoles.includes(role)
    })

    if (!hasRole) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like checkRole="['admin','editor']"`)
    return false
  }
}


// WEBPACK FOOTER //
// ./src/utils/permission.js